<!-- Documents Enhanced Widget -->
<div
    class="rounded-[24px] bg-white shadow-[0px_4px_10px_rgba(20,31,71,0.08)] p-[36px] flex flex-col gap-[24px] min-w-0 overflow-hidden">
    <!-- Header: title -->
    <div class="flex items-center gap-[12px] shrink-0">
        <span class="widget-title text-[#1c1c2e] tracking-[-0.27px]">Documents enhanced</span>
        <i class="pi pi-info-circle size-[16px] text-[#787B83]"
            pTooltip="Displays the total number of documents on which process AI features have been applied"
            tooltipPosition="top"></i>
    </div>

    <!-- Chart area -->
    <div class="flex flex-col gap-[12px]">
        <!-- Total + legend -->
        <div class="flex items-center justify-between gap-2 flex-wrap">
            <div class="flex items-center gap-[4px]">
                <span class="text-[22px] font-bold text-[#1c1c1c]">{{ data()?.total ?? 0 }}</span>
                <span class="text-sm font-normal text-[#1c1c1c] ml-1">Overall documents enhanced</span>
            </div>
            <div class="flex items-center gap-[16px]">
                <ng-container *ngFor="let l of legend">
                    <div class="flex items-center gap-2">
                        <span class="inline-block w-5 h-5 rounded-[3.8px] border-[0.635px] border-[#ccc]"
                            [style.background]="bucketStyles[l.bucket].bg"></span>
                        <span class="text-xs font-normal text-[#5f5f5f]">{{ l.label }}</span>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Scrollable table -->
        <div class="overflow-x-auto overflow-y-auto max-h-[400px] min-w-0">
            <table class="w-full min-w-[40rem] border-separate border-spacing-y-3">
                <tbody>
                    <tr *ngFor="let feature of data()?.features">
                        <th class="text-left align-middle pr-[8px] w-[140px] min-w-[140px] sticky left-0 bg-white z-10">
                            <div class="text-sm font-medium text-[#1c1c1c]">{{ feature.name }}</div>
                            <div class="text-xl font-bold text-[#1c1c1c]">{{ feature.total }}</div>
                        </th>
                        <td *ngFor="let bucket of feature.daily" class="px-[4px]">
                            <div class="w-[190px] h-[60px] rounded-3xl inline-flex justify-center items-center overflow-hidden"
                                [style.background]="bucketStyles[bucketFor(bucket.count)].bg"
                                [pTooltip]="formatDate(bucket.date) + ' — ' + bucket.count + ' docs'" tooltipPosition="top">
                                <div class="justify-start text-sm font-semibold"
                                    [style.color]="bucketStyles[bucketFor(bucket.count)].text">
                                    {{ bucket.count }}
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot class="sticky bottom-0 z-20">
                    <tr>
                        <th class="w-[140px] min-w-[140px] sticky left-0 bg-white z-30"></th>
                        <td *ngFor="let label of columnLabels()"
                            class="text-center text-sm font-normal text-[#5f5f5f] px-[4px] pb-1 bg-white">
                            {{ label }}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</div>